import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngrx/store";
import { timer } from "rxjs";
import { map, takeWhile } from "rxjs/operators";
import * as fromStore from "../../store/tasks";
import { AuditingState } from "../../store";
import * as fromAuth from "../../../../store/auth";

@UntilDestroy()
@Component({
    selector: 'app-auditor-ready-dialog',
    templateUrl: './auditor-ready-dialog.component.html',
    styleUrls: ['./auditor-ready-dialog.component.scss'],
    standalone: false
})
export class AuditorReadyDialogComponent implements OnInit, OnDestroy {
  timeRemaining$ = timer(0, 1000).pipe(
    map(n => (this.countdown - n) * 1000),
    takeWhile(n => n >= 0),
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) public countdown: number,
    public dialogRef: MatDialogRef<AuditorReadyDialogComponent>,
    private store: Store<{ auditing: AuditingState; auth: fromAuth.AuthState }>
  ) {
    this.timeRemaining$.pipe(untilDestroyed(this)).subscribe(countdown => {
      if (countdown === 0) this.dialogRef.close();
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  static open(dialog: MatDialog, countdown: number) {
    return dialog.open<AuditorReadyDialogComponent, number>(AuditorReadyDialogComponent, {
      data: countdown,
      disableClose: true,
      hasBackdrop: true
    });
  }

  close() {
    this.store.dispatch(fromStore.setIsAuditorReady({ isAuditorReady: true }));
    this.dialogRef.close();
  }

  stayOffline() {
    this.store.dispatch(fromStore.setIsAuditorReady({ isAuditorReady: false }));
    this.dialogRef.close();
  }
}
